export const CAPABILITES_LIST = "SUPPLIERS_PORTAL_CAPABILITES_LIST";
